import './inline-edit-input.scss';
import React, { useEffect, useRef, useState } from 'react';
import { InputProps, InputRef } from 'antd';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import { CustomInput } from '../custom-input/custom-input';

interface InlineEditInputProps extends InputProps {
    val: string;
    setVal: (val: string) => void;
    errorMessage?: string;
}

export const InlineEditInput: React.FC<InlineEditInputProps> = (props) => {
    const { val, setVal, errorMessage, disabled, maxLength } = props;
    const [editingValue, setEditingValue] = useState(val);
    const [isEditMode, setIsEditMode] = useState(false);
    const inputRef = useRef<InputRef>(null); // Declare and initialize inputRef

    useEffect(() => {
        setEditingValue(val);
    }, [val]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => setEditingValue(event.target.value);

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' || event.key === 'Escape') {
            event.currentTarget.blur();
            setIsEditMode(false);
        }
    };
    useEffect(() => {
        if (isEditMode) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [isEditMode]);

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        if (event.target.value.trim() === '') {
            setEditingValue(val);
        } else {
            setVal(event.target.value);
        }
        setIsEditMode(false);
    };

    return (
        <div className={`form-field-wrapper inline-edit-input-wrapper ${props.className}`}>
            <CustomInput ref={inputRef} inputType="INPUT"
                disabled={disabled}
                maxLength={maxLength}
                errorMessage={errorMessage}
                className={`inline-edit-input ${errorMessage ? 'has-error' : ''} ${props.className} ${isEditMode ? 'edit-mode' : ''}`}
                value={editingValue}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onFocus={() => setIsEditMode(true)}
                onBlur={onBlur}
            />
            {!props.disabled && !isEditMode && <CustomIcon className={`edit-icon`} type={IconType.PENCIL} onClick={() => setIsEditMode(true)} />}
        </div>
    );
};
